import { render, staticRenderFns } from "./table.component.vue?vue&type=template&id=3d410226&scoped=true&"
import script from "./table.component.vue?vue&type=script&lang=ts&"
export * from "./table.component.vue?vue&type=script&lang=ts&"
import style0 from "./table.component.vue?vue&type=style&index=0&id=3d410226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d410226",
  null
  
)

export default component.exports